import { useQuery } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";
import type { CarrierTrendData } from "../types";

/**
 * Standalone query for carrier-trend data with date-range params.
 * Separated from useDashboardMetrics so changing the date range only
 * refetches this card, not the entire dashboard.
 */
export function useCarrierTrend(startDate: string, endDate: string, enabled = true) {
  return useQuery<CarrierTrendData>({
    queryKey: ["trustcall", "dashboard", "carrier-flagged-30days", startDate, endDate],
    queryFn: () => {
      const params = new URLSearchParams({ startDate, endDate });
      return callApi(`${TC.DASHBOARD_CARRIER_30D}?${params}`, HttpMethod.GET);
    },
    enabled,
  });
}
